import React, { useState } from 'react';
import { Shuffle, ArrowUpDown } from 'lucide-react';
import SortPopover from './SortPopover';

/**
 * SearchControls component for shuffle and sort functions
 */
const SearchControls = ({ onShuffle, currentSort, onSortChange }) => {
  const [isSortOpen, setIsSortOpen] = useState(false);
  
  return (
    <div className="mb-4 flex space-x-2">
      <button 
        onClick={onShuffle} 
        className="shuffle-button"
        aria-label="Shuffle saved items"
      >
        <Shuffle className="inline-block mr-2" size={20} />
        Shuffle Saves
      </button>
      
      <div className="relative">
        <button
          onClick={() => setIsSortOpen(!isSortOpen)}
          className="shuffle-button"
          aria-label="Sort saved items"
        >
          <ArrowUpDown className="inline-block mr-2" size={20} />
          Sort Saves
        </button>
        
        {isSortOpen && (
          <SortPopover
            currentSort={currentSort}
            setSort={onSortChange}
            onClose={() => setIsSortOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default SearchControls;